<template>
  <div>
    <div class="tooltip">
      <div class="tooltop__container">
        <button
          class="tooltip__button"
          :class="['tooltip__button--' + tenant]"
          tabindex="0"
          @click="isVisible = !isVisible"
          :aria-label="'More informaton about ' + title"
          aria-describedby="extrainfo"
          ref="tooltip"
        ></button>
        <transition name="fade">
          <div
            v-show="isVisible"
            class="tooltip__arrow"
            role="presentation"
          ></div>
        </transition>
      </div>

      <transition name="fade">
        <div
          v-show="isVisible"
          class="tooltip-box"
          :class="positionClass"
          role="tooltip"
          id="extrainfo"
          aria-hidden="isVisible"
          ref="tooltipContent"
        >
          <h2 class="tooltip-box__title">
            {{ title }}
          </h2>
          <p class="tooltip-box__text">
            {{ text }}
          </p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    title: {
      type: String,
      default: "This is the title"
    },
    text: {
      type: String,
      default: "This is the text"
    }
  },
  data() {
    return {
      isVisible: false,
      positionClass: null,
      tenant: process.env.NUXT_TENANT
    };
  },
  watch: {
    isVisible(value) {
      setTimeout(() => {
        this.adjustPosition();
      }, 10);

      if (value === true) {
        /*
         ** Analytic event
         */
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "GAEvent",
          eventCategory: "Transfers Checkout Interaction",
          eventAction: "Information Icon",
          eventLabel: this.title
        });
      }
    }
  },
  methods: {
    adjustPosition() {
      const bounding = this.$refs.tooltipContent.getBoundingClientRect();
      const leftPositionOutOfView = Boolean(Math.sign(bounding.left) === -1);
      const rightPositionOutOfView =
        bounding.right > document.documentElement.clientWidth;
      if (leftPositionOutOfView) {
        this.positionClass = "tooltip-box--left";
      } else if (rightPositionOutOfView) {
        this.positionClass = "tooltip-box--right";
      } else {
        this.positionClass = null;
      }
    },
    closeTooltip(event) {
      if (!this.$refs.tooltip.contains(event.target)) {
        this.isVisible = false;
      }
    },
    handleScroll() {
      this.isVisible = false;
    }
  },
  created() {
    window.addEventListener("click", this.closeTooltip);
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("click", this.closeTooltip);
  }
};
</script>
<style lang="scss" scoped>
$tooltip-width: 280px;
$tooltip-iphone5-width: 220px;
.tooltip {
  position: relative;

  &__container {
    display: inline-flex;
    position: relative;
  }

  &__button {
    position: relative;
    background-image: url("./tooltip-icon.svg");
    font-size: $base-font-size;
    cursor: pointer;
    width: 20px;
    height: 20px;
    border: 0;
    margin: 0;
    &:focus,
    &:hover {
      background-image: url("./tooltip-focus-icon.svg");
    }
    &--adl {
      background-image: url("./tooltip-icon-adl.svg");
      &:focus,
      &:hover {
        background-image: url("./tooltip-focus-icon-adl.svg");
      }
    }
  }

  &__arrow {
    z-index: 10000;
    bottom: -8px;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(136, 183, 213, 0);
    border-bottom-color: $success;
    border-width: 10px;
  }

  &-box {
    display: flex;
    flex-direction: column;
    position: absolute;
    z-index: 1500;
    width: $tooltip-width;
    top: 33px;
    padding: 12px 10px;
    border-radius: 5px;
    transform: translateX(calc(-50% - 10px));
    background-color: $success;
    box-shadow: 0 2px 10px rgba(42, 56, 72, 0.4);
    @media (max-width: 360px) {
      width: $tooltip-iphone5-width;
    }

    &--left {
      left: 90px;
    }
    &--right {
      left: -105px;
      @media (max-width: 360px) {
        left: -55px;
      }
    }

    &__title,
    &__text {
      color: $white;
      padding: 0;
      margin: 0;
    }

    &__title {
      font-size: $base-font-size * 1.8;
      font-weight: theme-weight(demi);
      margin-bottom: 8px;
    }
    &__text {
      font-size: $base-font-size * 1.6;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-in-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
